export const EXSBPAYMENTWAY_DELETE_RESET = 'EXSBPAYMENTWAY_DELETE_RESET'
export const EXSBPAYMENTWAY_DELETE_SET_ERROR = 'EXSBPAYMENTWAY_DELETE_SET_ERROR'
export const EXSBPAYMENTWAY_DELETE_SET_DELETED = 'EXSBPAYMENTWAY_DELETE_SET_DELETED'
export const EXSBPAYMENTWAY_DELETE_TOGGLE_LOADING = 'EXSBPAYMENTWAY_DELETE_TOGGLE_LOADING'
